import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNil } from 'ramda';
import * as CommonDesign from '@prezi/common-design';
import { actions } from '../../../store/actions/actions';
import * as Atoms from '../dumb';
import { DisabledComponentWithTooltipWrapper } from '../../molecules/dumb';
import { createDataLookup } from '../../const';
import { localI18n } from '../../../i18n';
const uxCopy = {
  button: localI18n._("Embed")
};
const uxCopyTooltip = {
  title: localI18n._("Not allowed to embed"),
  body: localI18n._("Only collaborators can access this document")
};
const ButtonDisabled = () => React.createElement(DisabledComponentWithTooltipWrapper, {
  uxCopyTooltip: uxCopyTooltip
}, React.createElement(Atoms.PrimaryButton, {
  disabled: true,
  variant: "transparent",
  "data-lookup": createDataLookup('embed-button')
}, React.createElement(CommonDesign.IconSmallCodeLegacy, null), React.createElement("span", null, uxCopy.button)));
const ButtonEnabled = () => {
  const dispatch = useDispatch();
  return React.createElement(Atoms.PrimaryButton, {
    onClick: () => dispatch(actions.setPage('embed')),
    variant: "transparent",
    "data-lookup": createDataLookup('embed-button')
  }, React.createElement(CommonDesign.IconSmallCodeLegacy, null), React.createElement("span", null, uxCopy.button));
};
const EmbedButton = () => {
  const canEmbed = useSelector(state => {
    var _state$unifiedPrivacy;
    return !isNil((_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.embed_link);
  });
  return canEmbed ? React.createElement(ButtonEnabled, null) : React.createElement(ButtonDisabled, null);
};
export default EmbedButton;